module.exports = __webpack_public_path__ + "img/floating-window-bf.dec8bc65.png";